import React, { useState, useEffect, useContext } from 'react';

import Box from '@mui/material/Box';

import Typography from '@mui/material/Typography';

// import { useNavigate } from 'react-router-dom';
import { Link } from '@mui/material';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import { Button } from '@mui/material';
import CallOutlinedIcon from '@mui/icons-material/CallOutlined';
import { AuthContext } from '../../Context/AuthProvider';


function AssignmentRejectComp({ AssignmentDetailsAry, status, AssignmentCancelReasonSelectShow, AssignmentCancelReasonCancellationCode }) {
    const { currentUser } = useContext(AuthContext);
    const [AssignStatusMessageTitle, AssignStatusMessageTitleSet] = useState('');
    const [AssignStatusMessage, AssignStatusMessageSet] = useState('');
    // const navigate = useNavigate();
    let support_tel_number = process.env.REACT_APP_ASSIGN_ACCEPT_SUPPORT_CALL_NUMBER;
    const appThemeColor = "#" + process.env.REACT_APP_THEME_COLOR;
    let iti_user_full_name = currentUser['custom:first_name'] + " " + currentUser['custom:last_name'];

    useEffect(() => {
        if (status === 'Rejected') {
            AssignStatusMessageTitleSet('Assignment Rejected');
            // AssignStatusMessageSet("You just rejected the assignment " + AssignmentDetailsAry.assign_orderid);
            AssignStatusMessageSet("You've decided not to take on this assignment. If there are specific reasons or concerns you'd like to share");
        } else if (status === 'Cancelled') {
            AssignStatusMessageTitleSet('Cancelled Assignment');
            AssignStatusMessageSet(
                iti_user_full_name + ", you have withdrawn from this assignment and shared the following reason: " +
                (AssignmentCancelReasonSelectShow || AssignmentCancelReasonCancellationCode)
            );
        } else if (status === 'No_Access') {
            AssignStatusMessageTitleSet('Oops!');
            AssignStatusMessageSet("You Are Not Able to Access this Assignment...!");
        }


    }, []);
    return (
        // <Box sx={{ mt: 2, mb: 2 }}>
        //     <Card sx={{ backgroundColor: '#EB5757', borderRadius: 1, boxShadow: '#EB5757 0px 0px 5px' }}>
        //         <CardContent   >
        //             <Box sx={{ mt: 2 }}>
        //                 <Typography variant='h4' color="white" align='center' fontWeight='bold'>{AssignStatusMessageTitle}</Typography>
        //             </Box>
        //             <Box sx={{ mt: 2 }}>


        //                 {/* <Typography variant='h4' color="white" align='center' >{iti_user_full_name + ","}</Typography> */}
        //                 <Typography variant='h5' color="white" align='center' >{AssignStatusMessage}</Typography>
        //             </Box>
        //             {status === 'Rejected' && <Box sx={{ mt: 2, mb: 2 }}>
        //                 <Box sx={{ display: 'flex', justifyContent: 'center' }}>
        //                     <Button sx={{ backgroundColor: 'white', color: 'black', textTransform: 'none', fontWeight: 'bold', '&:hover': { backgroundColor: 'white' } }} component={Link} href={"tel:" + support_tel_number} startIcon={<CallOutlinedIcon />} variant='contained'>
        //                         Call ITI
        //                     </Button></Box>
        //             </Box>}



        //         </CardContent>
        //     </Card>



        // </Box>
        null
    )
}

export default AssignmentRejectComp